import type { AxiosResponse } from 'axios'
import type { QueryClient } from 'react-query'

import { zervantSettingsQueryKey } from '../../../constants/zervantSettingsQueryKey'
import type { PaymentMethod } from '../../../types/paymentMethod'
import type { ZervantSettings } from '../../../types/zervantSettings'
import type { PaymentMethodsSettings } from '../types/paymentMethods/paymentMethodsSettings'
import { getPaymentMethodsPayload } from './getPaymentMethodsPayload'

// Takes the caller's useQueryClient() instance: tests render with their own client, not the app singleton.
export const getCachedPaymentMethodsPayload = (
  formValues: PaymentMethodsSettings,
  queryClient: QueryClient,
): PaymentMethod[] => {
  // paymentMethods is replaced wholesale, so the array has to start from the cache at save time.
  const cachedSettingsResponse = queryClient.getQueryData<AxiosResponse<ZervantSettings>>(zervantSettingsQueryKey)

  if (!cachedSettingsResponse?.data) {
    throw new Error('Invoicing settings cache is empty')
  }

  return getPaymentMethodsPayload(cachedSettingsResponse.data.values.paymentMethods, formValues)
}
